import { otherLanguages as allOtherLanguages } from 'i18n/constants'
import Head from 'next/head'
import { useTranslation } from 'next-i18next'
import { DefaultSeo, NextSeo } from 'next-seo'
import { getOgImageURL } from 'services/ogimage'
import urljoin from 'url-join'

export function Seo({
    path = '/',
    title = '',
    description = '',
    lang = 'en',
    otherLanguages = allOtherLanguages,
    ...rest
}) {
    const host = process.env.BASE_URL
    const alternateUrls = [
        { lang: 'en', href: urljoin(host, path) },
        { lang: 'x-default', href: urljoin(host, path) },
    ]
    if (otherLanguages) {
        const otherLangUrls = otherLanguages.map((lang) => {
            return {
                lang: lang,
                href: urljoin(host, lang, path),
            }
        })
        alternateUrls.push(...otherLangUrls)
    }
    const canonical = alternateUrls.find((alt) => alt.lang === lang)
    return (
        <>
            <NextSeo
                title={title}
                description={description}
                canonical={canonical?.href}
                openGraph={{ title, description, ...rest }}
            />
            <Head>
                {alternateUrls.map((alternate) => (
                    <link
                        key={`alternate-${alternate.lang}`}
                        rel="alternate"
                        hrefLang={alternate.lang}
                        href={alternate.href}
                    />
                ))}
            </Head>
        </>
    )
}

export function TwistDefaultSeo() {
    const { t, i18n } = useTranslation('common')
    const sitename = 'Twist'
    const title = t('seo.title')
    const description = t('seo.description')
    const images = [{ url: getOgImageURL('og-image-default.jpg'), alt: t('seo.imageAlt') }]
    const twitterUsername = '@usetwist'
    const removeFromIndexing = process.env.APP_ENV !== 'production'
    const baseURL = process.env.BASE_URL
    return (
        <DefaultSeo
            title={title}
            description={description}
            openGraph={{
                title,
                description,
                images,
                site_name: sitename,
                url: baseURL,
                type: 'website',
                locale: i18n.language,
            }}
            twitter={{
                site: twitterUsername,
                handle: twitterUsername,
                cardType: 'summary_large_image',
            }}
            dangerouslySetAllPagesToNoIndex={removeFromIndexing}
            dangerouslySetAllPagesToNoFollow={removeFromIndexing}
        />
    )
}
